import { Button, ButtonProps } from '@chakra-ui/react'
import { Label } from 'components/typography'
import Link from 'next/link'
import { FC } from 'react'

interface StandardButtonProps extends ButtonProps {
  text?: string
  href?: string
  colorScheme?: 'dandelion' | 'phthalo' | 'medleve' | 'cuidei'
  htmlFor?: string
}

const StandardButton: FC<StandardButtonProps> = ({
  text,
  href,
  onClick,
  colorScheme = 'dandelion',
  children,
  ...props
}) => {
  const isCuidei = colorScheme === 'cuidei'
  const btnTextColor = colorScheme === 'phthalo' || colorScheme === 'medleve' || isCuidei ? 'alabaster' : 'phthalo'
  const hoverColor = isCuidei ? 'cuidei.70' : colorScheme === 'dandelion' ? 'yellow.50' : 'cyan.90'
  // `cuidei` is a nested color scale (cuidei.60), unlike the flat dandelion/medleve tokens.
  const bgColor = isCuidei ? 'cuidei.60' : colorScheme
  const PureButton: FC = () => (
    <Button
      _hover={{
        bg: hoverColor
      }}
      bg={bgColor}
      boxShadow="none"
      h="48px"
      onClick={onClick}
      type="button"
      {...props}
    >
      {children || <Label color={btnTextColor}>{text}</Label>}
    </Button>
  )

  return (
    <>
      {href ? (
        <Link prefetch={false} href={href} passHref>
          <PureButton />
        </Link>
      ) : (
        <PureButton />
      )}
    </>
  )
}

export default StandardButton
